(function () {
  // =========================
  // CONFIG
  // =========================
  var DEBUG = false;         // true para logs
  // =========================

  if (window.stickyAtcLoaded) return;
  window.stickyAtcLoaded = true;

  function log() { if (DEBUG) console.log.apply(console, arguments); }

  // =========================
  // DOM helpers
  // =========================
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var stickyWrapper = qs('#sticky-atc-wrapper');
  var stickyBtn = qs('#sticky-atc-btn');
  var overlay = qs('#sticky-atc-overlay');
  var modal = qs('#sticky-atc-modal');
  var closeBtn = qs('#sticky-atc-close-btn');
  var confirmBtn = qs('#sticky-atc-confirm-btn');
  var sizeOptionsEl = qs('#sticky-atc-size-options');
  var findSizeBtn = qs('#sticky-atc-find-size-btn');
  var sizeGuideBtn = qs('#sticky-atc-size-guide-btn');
  var sizeSeparator = qs('.sticky-atc-size-separator');

  function updateDynamicLinks() {
    var sizeBayBtn = document.getElementById('szb-vfr-button');
    var sizeMeasurementsBtn = document.getElementById('szb-measurements-button');

    if (findSizeBtn) {
      findSizeBtn.style.display = sizeBayBtn ? '' : 'none';
    }

    if (sizeGuideBtn) {
      sizeGuideBtn.style.display = sizeMeasurementsBtn ? '' : 'none';
    }

    if (sizeSeparator) {
      var isFindSizeVisible = findSizeBtn && findSizeBtn.style.display !== 'none';
      var isSizeGuideVisible = sizeGuideBtn && sizeGuideBtn.style.display !== 'none';
      sizeSeparator.style.display = (isFindSizeVisible && isSizeGuideVisible) ? '' : 'none';
    }
  }

  // =========================
  // ATC: selector exacto a tu tema
  // =========================
  function getAddToCartButton() {
    var btn = document.querySelector('[data-block-type="buy-buttons"] form[action^="/cart/add"] buy-buttons button[type="submit"]');
    if (btn) return btn;

    return document.querySelector(
      [
        'form[action^="/cart/add"] buy-buttons button[type="submit"]',
        'form[action^="/cart/add"] button[type="submit"]',
        'button[name="add"]',
        'button.product-form__submit'
      ].join(',')
    );
  }

  function isActuallyVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    // Fallback/direct DOM measurement for iOS Safari reliability
    var topObstruction = 0;
    var headerEl = document.querySelector('store-header, .header, #shopify-section-header');
    if (headerEl) {
      var hRect = headerEl.getBoundingClientRect();
      if (hRect.bottom > 0) {
        topObstruction = hRect.bottom;
      }
    }

    // Consider the default CTA "visible" as long as half of it is not under the header stack.
    // Sticky CTA should appear as soon as half the default CTA is underneath the header.
    // We add + 150 to window.innerHeight to prevent iOS Safari bottom address bar from falsely triggering it.
    return (rect.top + (rect.height)) > topObstruction && rect.top < (window.innerHeight + 150);
  }

  function isAddToCartVisible() {
    var btn = getAddToCartButton();
    return isActuallyVisible(btn);
  }

  function toggleSticky() {
    if (!stickyWrapper) return;
    if (window.innerWidth >= 700) {
      stickyWrapper.classList.remove('is-visible', 'visible');
      document.body.classList.remove('sticky-atc-visible');
      return;
    }
    try {
      document.documentElement.style.setProperty('--sticky-atc-height', (stickyWrapper.offsetHeight || 0) + 'px');
    } catch (e) {}
    stickyWrapper.classList.add('is-visible', 'visible');
    document.body.classList.add('sticky-atc-visible');
  }

  // =========================
  // TALLAS (asume option2 = talla)
  // =========================
  function getSelectedSize() {
    var checked = qs('input[name="sticky-atc-size"]:checked');
    return checked ? checked.value : null;
  }

  function isSimilarModeEnabled() {
    return !!(modal && modal.getAttribute('data-ym-similar-enabled') === 'true');
  }

  function getStickyProductHandle() {
    return modal ? (modal.getAttribute('data-product-handle') || '') : '';
  }

  function findStickySizeOption(sizeValue) {
    if (!sizeOptionsEl) return null;
    var options = qsa('.sticky-atc-size-option', sizeOptionsEl);
    for (var i = 0; i < options.length; i++) {
      var input = qs('input[name="sticky-atc-size"]', options[i]);
      if (input && input.value === sizeValue) return options[i];
    }
    return null;
  }

  function findOriginalInputByValue(value) {
    try {
      var inputs = qsa('input[name="option2"], input[name^="option"]');
      var matchedInput = null;
      var currentVal = CSS.escape ? CSS.escape(value) : value.replace(/"/g, '\\"');

      // Primarily strictly look at option2
      var option2 = document.querySelector('input[name="option2"][value="' + currentVal + '"]');
      if (option2) return option2;

      // Fallback: try finding an exact match across any option if they changed the name
      inputs.forEach(function (inp) {
        if (inp.value === value) { matchedInput = inp; }
      });
      return matchedInput;
    } catch (e) {
      return null;
    }
  }

  function isSizeOutOfStock(sizeValue) {
  try {
    var sizeOption = findStickySizeOption(sizeValue);
    if (!sizeOption) return false;
    return !sizeOption.classList.contains('available');
  } catch (e) {
    return false;
  }
}


  function updateModalHeightVar() {
    if (modal && modal.classList.contains('active')) {
      try {
        document.documentElement.style.setProperty('--sticky-modal-height', (modal.offsetHeight || 0) + 'px');
      } catch (e) {}
    }
  }

  function updateButtonState() {
    if (!confirmBtn) return;
    var selected = getSelectedSize();
    var hasSize = !!selected;

    if (!hasSize) {
      confirmBtn.disabled = true;
      confirmBtn.classList.remove('restock-mode');
      updateModalHeightVar();
      return;
    }

    confirmBtn.disabled = false;

    // Do not show the below CTA for out-of-stock variants anymore,
    // since selecting an out-of-stock variant will trigger the popup directly.
    confirmBtn.classList.remove('restock-mode');
    
    updateModalHeightVar();
    setTimeout(updateModalHeightVar, 50);
  }

  function getPriceText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    var srOnly = clone.querySelector('.sr-only');
    if (srOnly) srOnly.remove();
    return clone.textContent.trim();
  }

  function updatePrice() {
    var stickyPriceEl = qs('.sticky-atc-price');
    var priceBlock = document.querySelector(".product-info__block-item[data-block-type='price']");
    if (!stickyPriceEl || !priceBlock) return;

    var mainSaleEl = priceBlock.querySelector('sale-price');
    var mainCompareEl = priceBlock.querySelector('compare-at-price');
    var isOnSale = !!(mainCompareEl && !mainCompareEl.hidden);

    stickyPriceEl.classList.toggle('sticky-atc-price--on-sale', isOnSale);

    if (isOnSale) {
      var compareText = getPriceText(mainCompareEl);
      var saleText = getPriceText(mainSaleEl);
      var compareSpan = qs('.sticky-atc-price__compare', stickyPriceEl);
      var saleSpan = qs('.sticky-atc-price__sale', stickyPriceEl);

      if (!compareSpan || !saleSpan) {
        stickyPriceEl.innerHTML =
          '<span class="sticky-atc-price__compare">' + compareText + '</span>' +
          '<span class="sticky-atc-price__sale">' + saleText + '</span>';
      } else {
        compareSpan.textContent = compareText;
        saleSpan.textContent = saleText;
      }
    } else if (mainSaleEl) {
      stickyPriceEl.innerHTML = getPriceText(mainSaleEl);
    }

    updateModalHeightVar();
    setTimeout(updateModalHeightVar, 50);
  }

  document.addEventListener('variant:change', function (e) {
    setTimeout(updatePrice, 50);
  });

  function syncSizeToOriginal(selectedValue) {
    try {
      var originalInput = findOriginalInputByValue(selectedValue);
      if (!originalInput) return;

      var inputs = qsa('input[name="' + originalInput.name + '"]');
      inputs.forEach(function (i) { i.checked = false; });
      originalInput.checked = true;

      originalInput.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(updateButtonState, 100);
    } catch (e) {
      log('syncSize error', e);
    }
  }

  function updateSizeOptionsState() {
    if (!sizeOptionsEl) return;
    var current = getSelectedSize();
    var options = qsa('.sticky-atc-size-option', sizeOptionsEl);
    var similarEnabled = isSimilarModeEnabled();

    var originalSelected = qs('input[name="option2"]:checked');
    if (originalSelected && !current) {
      current = originalSelected.value;
    }

    options.forEach(function (opt) {
      var input = qs('input', opt);
      if (!input) return;

      var sizeValue = input.value;
      var oos = isSizeOutOfStock(sizeValue);
      var isChecked = (sizeValue === current);
      var label = qs('label', opt);

      input.checked = isChecked;
      input.disabled = !!(oos && similarEnabled);

      if (oos) {
        opt.classList.add('out-of-stock');
        if (label) label.classList.add('block-swatch', 'is-disabled');

        if (similarEnabled) {
          opt.classList.add('similar-mode');
        } else {
          opt.classList.remove('similar-mode');
        }
      } else {
        opt.classList.remove('out-of-stock', 'similar-mode');
        input.disabled = false;
        if (label) label.classList.remove('block-swatch', 'is-disabled');
      }
    });

    updateButtonState();
  }
  function openSizeModal() {
    updateSizeOptionsState();
    updateDynamicLinks();
    // Pause observer so DOM changes don't accidentally hide the sticky bar
    if (mo) mo.disconnect();
    if (overlay) overlay.classList.add('active');
    if (modal) {
      modal.style.display = 'block';
      setTimeout(function () {
        modal.classList.add('active');
        updateModalHeightVar();
      }, 10);
    }
    document.body.classList.add('sticky-atc-modal-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSizeModal() {
    if (modal) modal.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.classList.remove('sticky-atc-modal-open');
    setTimeout(function () {
      if (modal) modal.style.display = 'none';
      document.body.style.overflow = '';
      // Resume observer after modal is fully closed
      if (mo) mo.observe(document.documentElement, { childList: true, subtree: true });
    }, 350);
  }

  function dispatchStickyTrackingEvent(detail) {
    document.dispatchEvent(new CustomEvent('gtm:sticky-atc', {
      bubbles: true,
      detail: detail
    }));
  }

  function trackStickySizeSelection(input) {
    if (!input) return;

    var sizeOption = input.closest('.sticky-atc-size-option');
    dispatchStickyTrackingEvent({
      action: 'size_select',
      linkText: input.value,
      inStock: sizeOption ? !sizeOption.classList.contains('out-of-stock') : true
    });
  }

 function triggerSimilarAction(sizeOption) {
  if (!sizeOption) return;

  var input = qs('input[name="sticky-atc-size"]', sizeOption);
  if (!input) return;

  document.dispatchEvent(new CustomEvent('ym:similar-size', {
    bubbles: true,
    detail: {
      size: input.value,
      productHandle: getStickyProductHandle(),
      source: 'sticky_atc'
    }
  }));

  log('Similar size requested', input.value);
}

  function scheduleStickyAddToCart() {
    setTimeout(function () {
      addToCart();
    }, 150);
  }

  var isAddingToCart = false;

  function addToCart() {
    if (isAddingToCart) return;
    isAddingToCart = true;
    try {
      var selectedSize = getSelectedSize();
      var outOfStock = selectedSize ? isSizeOutOfStock(selectedSize) : false;

      if (!selectedSize) {
        alert('Por favor, selecciona una talla');
        isAddingToCart = false;
        return;
      }

      if (outOfStock && isSimilarModeEnabled()) {
        triggerSimilarAction(findStickySizeOption(selectedSize));
        isAddingToCart = false;
        return;
      }

      syncSizeToOriginal(selectedSize);

      setTimeout(function () {
        if (outOfStock) {
          closeSizeModal();
          setTimeout(function () {
            var restockBtn = qs('.restock-rocket-button-cover');
            if (restockBtn) restockBtn.click();
            isAddingToCart = false;
          }, 400);
        } else {
          var btn = getAddToCartButton();
          if (btn) {
            btn.click();
            setTimeout(function() {
              closeSizeModal();
              isAddingToCart = false;
            }, 600);
          } else {
            isAddingToCart = false;
          }
        }
      }, 200);
    } catch (e) {
      log('addToCart error', e);
      isAddingToCart = false;
    }
  }

  // =========================
  // EVENTOS
  // =========================
  function pushStickyAtcButtonEvent() {
    if (!stickyBtn) return;

    var buttonTextEl = stickyBtn.querySelector('.sticky-atc-btn-text');
    var buttonText = ((buttonTextEl && buttonTextEl.textContent) || stickyBtn.textContent || '').trim();
    var linkText = buttonText
      .replace(/\s+/g, ' ')
      .toLowerCase();

    if (!linkText) return;

    var eventData = {
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: 'click_on_button',
      element: 'button',
      position: 'add_to_cart',
      link_text: linkText,
      url_destination: null
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    if (typeof Shopify !== 'undefined' && Shopify.analytics) {
      Shopify.analytics.publish('custom_event', eventData);
    }
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      dispatchStickyTrackingEvent({
        action: 'open_modal',
        linkText: (qs('.sticky-atc-btn-text', stickyBtn) || stickyBtn).textContent.trim()
      });
      pushStickyAtcButtonEvent();
      openSizeModal();
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeSizeModal);
  if (overlay) overlay.addEventListener('click', closeSizeModal);
  if (confirmBtn) confirmBtn.addEventListener('click', addToCart);

  if (findSizeBtn) {
    findSizeBtn.addEventListener('click', function () {
      closeSizeModal();
      setTimeout(function () {
        var sizeBayBtn = document.getElementById('szb-vfr-button');
        if (sizeBayBtn) sizeBayBtn.click();
      }, 400);
    });
  }

  if (sizeGuideBtn) {
    sizeGuideBtn.addEventListener('click', function () {
      closeSizeModal();

      // Wait for the sticky selection modal to fully close (350ms animation)
      // before opening the size guide modal (fixed ID rendered in Liquid).
      setTimeout(function() {
        var modalEl = document.getElementById('szb-measurements-button');
        if(modalEl) {
          modalEl.click();
        }
      }, 400);
    });
  }

  if (sizeOptionsEl) {
  sizeOptionsEl.addEventListener('click', function (e) {
    var sizeOption = e.target && e.target.closest
      ? e.target.closest('.sticky-atc-size-option')
      : null;

    if (!sizeOption) return;

    var input = qs(
      'input[name="sticky-atc-size"]',
      sizeOption
    );

    var clickedLabel = e.target.closest('label');
    var clickedSimilar = e.target.closest('.text-similar');

    if (!clickedLabel && !clickedSimilar) return;

    /*
     * TALLA AGOTADA CON VER SIMILARES
     */
    if (sizeOption.classList.contains('similar-mode')) {
      e.preventDefault();
      e.stopPropagation();

      triggerSimilarAction(sizeOption);

      return;
    }

    /*
     * La talla ya estaba seleccionada.
     *
     * Esto es especialmente importante en productos
     * con una única talla. En ese caso el radio puede
     * estar marcado antes del clic y, por tanto, el
     * navegador no dispara el evento "change".
     *
     * Forzamos entonces el add-to-cart desde el clic.
     */
    if (input && input.checked) {
      e.preventDefault();
      e.stopPropagation();

      trackStickySizeSelection(input);

      scheduleStickyAddToCart();
    }
  });

  sizeOptionsEl.addEventListener('change', function (e) {
    if (
      !e.target ||
      !e.target.matches('input[name="sticky-atc-size"]') ||
      !e.target.checked
    ) {
      return;
    }

    var sizeVal = e.target.value;
    var sizeOption = e.target.closest(
      '.sticky-atc-size-option'
    );

    /*
     * TALLA AGOTADA CON VER SIMILARES
     */
    if (
      sizeOption &&
      sizeOption.classList.contains('similar-mode')
    ) {
      e.target.checked = false;

      triggerSimilarAction(sizeOption);

      return;
    }

    /*
     * TALLA NORMAL
     */
    trackStickySizeSelection(e.target);

    syncSizeToOriginal(sizeVal);

    scheduleStickyAddToCart();
  });
}

  document.addEventListener('change', function (e) {
    if (e.target && (e.target.matches('input[name="option2"]') || e.target.matches('input[name^="option"]'))) {
      updateSizeOptionsState();
      updateButtonState();
    }
  });

  var scrollTimeout;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(toggleSticky, 50);
  });

  window.addEventListener('resize', toggleSticky);
  window.addEventListener('orientationchange', toggleSticky);

  var mo = new MutationObserver(function () {
    // Skip if modal is open — toggleSticky guard handles this but
    // early-exit avoids unnecessary work
    if (!document.body.classList.contains('sticky-atc-modal-open')) {
      toggleSticky();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // =========================
  // INIT
  // =========================
  setTimeout(toggleSticky, 200);
  setTimeout(function() {
    toggleSticky();
    updateDynamicLinks();
    updatePrice();
  }, 1200);
  
  // SizeBay often loads late, so we check again
  setTimeout(updateDynamicLinks, 3000);
  setTimeout(updateDynamicLinks, 6000);

  log('Sticky CTA listo (Theme-based)');
})();

(function() {
  let attempts = 0;
  const intervalId = setInterval(() => {
    attempts++;
    const popConvert = document.querySelector('.gw-rd-popup-widget-placeholder');          
    if (popConvert && popConvert.shadowRoot) {
      if (!popConvert.shadowRoot.querySelector('#style-link')) {
        const styleLink = document.createElement('link');
        styleLink.id = "style-link";
        styleLink.rel = "stylesheet";
        styleLink.href = window.popConvertCss;
        styleLink.type = "text/css";
        popConvert.shadowRoot.appendChild(styleLink);
      }
    }
    
    const success = popConvert && popConvert.shadowRoot && popConvert.shadowRoot.querySelector('#style-link');
    if (success || attempts >= 30) {
      clearInterval(intervalId);
    }
  }, 1000);
})();